import { LastPost } from "../../components/Library/LastPosts"
import { Diagnoses } from "../../components/OscHome/Diagnoses"
import { DiagnosesAnswered } from "../../components/OscHome/DiagnosesAnswered"
import { HomeSlider } from "../../components/OscHome/HomeSlider"
import OscProgressInfo from "../../components/OscProgressInfo"
import { OscLoggedLayout } from "../../layout/OscLoggedLayout"


const Home = () => {

    return (
        <OscLoggedLayout>
            <div className="flex flex-1 h-full relative">
                <div className="h-full w-full overflow-auto">
                    <HomeSlider />
                    <Diagnoses/>
                    <DiagnosesAnswered/>
                    <LastPost/>
                </div>
                <OscProgressInfo />
            </div>

        </OscLoggedLayout>
    )
}


export default Home
